
//// FAQ
(function($, window, undefined) {

  var defaults = {}

  function wbskFAQ(element,settings) {
    this.wrapper = $(element)
    this.init()
  }

  wbskFAQ.prototype = {
    
    init:function(){
      var _this = this,
          wrapper = _this.wrapper      
      wrapper.find('h2,h3').addClass('wbsk-faq__heading')
      wrapper.find('h3').each(function(){
        $(this).addClass('wbsk-faq__question')
        $(this).nextUntil('.wbsk-faq__heading').wrapAll('<div class="wbsk-faq__content">')
      })
      
      _this.bind()
    },
    

    closeAll:function(){
      $('.wbsk-faq__question').removeClass('wbsk-faq__question--active')
      $('.wbsk-faq__content').slideUp(200)
    },
    
    bind: function() {      
      var _this = this
      $(document).on('click','.wbsk-faq__question',function(){
        if(!$(this).hasClass('wbsk-faq__question--active')){
          _this.closeAll()
          $(this).addClass('wbsk-faq__question--active')
          $(this).next('.wbsk-faq__content').slideDown(200)
        }else{
          $(this).addClass('wbsk-faq__question--active')
          $(this).next('.wbsk-faq__content').slideDown(200)
        }
      })
    }
  }
  
  $.fn.wbskFAQ = function(settings) {
    return this.each(function () {
      $.data(this, 'wbskFAQ', new wbskFAQ(this, settings))
    })
  }

}(jQuery, window));
